import ActionTypes from '../constants/ActionTypes';

// Generic toast action that accepts type, message, and optional apiErrorInfo
export const showToast = (toastType, message, apiErrorInfo = null) => ({
  type: ActionTypes.SHOW_TOAST,
  toastType,
  message,
  apiErrorInfo,
});

// Convenience functions for backward compatibility
export const showErrorToast = (message, apiErrorInfo) =>
  showToast('danger', message, apiErrorInfo);

export const showWarningToast = message => showToast('warning', message);

export const showInfoToast = message => showToast('primary', message);

export const showSuccessToast = message => showToast('success', message);

export const showVoiceDetectedToast = (message, apiErrorInfo) =>
  showToast('voice-detected', message, apiErrorInfo);

export const hideToast = () => ({
  type: ActionTypes.HIDE_TOAST,
});
